import { useQuery } from '@tanstack/react-query';
import { CommonEvaluation } from '@codidae/common-types';
import { getEvaluations } from 'services/evaluations';

export function useEvaluations(childrenId: number) {

  const {
    data: evaluations,
    isLoading,
    error,
    refetch
  } = useQuery<CommonEvaluation[], Error>({
    queryKey: ['getEvaluations', childrenId],
    queryFn: () => getEvaluations(childrenId),
    enabled: !!childrenId,
    staleTime: 60 * 1000,
    gcTime: 60 * 1000,
  });

  // Trouver une évaluation par son ID (gardé)
  const findEvaluationById = (id: number): CommonEvaluation | undefined => 
    evaluations?.find((evaluation: CommonEvaluation) => evaluation.id === id);

  // Trouver l'évaluation la plus récente (gardé)
  const findLatestEvaluation = (): CommonEvaluation | undefined => {
    if (!Array.isArray(evaluations) || evaluations.length === 0) return undefined;
    return [...evaluations].sort(
      (a: CommonEvaluation, b: CommonEvaluation) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    )[0];
  };

  return {
    evaluations,
    isLoading,
    error,
    refetch,
    findEvaluationById,
    findLatestEvaluation
  };
} 